<icc-list [searchable]="true" [items]="drives"
          [itemTemplate]="'itemImgTitleDescription'"
          itemImgHeight="medium"
          [selected]="selectedDriveId"
          (select)="selectDrive($event)"></icc-list>
